"use client";
import ScreenLayout from "@/components/layout/screen-layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Testimonial_Company_Team_Review_Card_Stories_Devkrest } from "@/lib/dto/home/stories-devkrest/stories-devkrest-data";

import { ChevronRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

const TestimonialReviewSection = () => {
  return (
    <ScreenLayout>
      <div className="flex justify-center items-center pt-6.5 md:pt-13 pb-12 md:pb-24">
        {/* <div className=" grid gap-y-13 md:gap-x-13 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <div className="sm:col-span-2">
            <Card className="shadow-none py-8.5 px-12.5 gap-0 rounded-[20px] md:h-98 md:w-206">
              <CardHeader className="px-0 gap-0">
                <Image
                  src={Vuor1TeamImg}
                  alt="Vuor Team Member"
                  className="size-10 object-cover"
                />
              </CardHeader>
              <CardContent className="px-0 pt-5.5">
                <p className="text-lg font-medium">
                  "Since we switched to Aircall, our average CSAT has gone up
                  4%, which is fantastic. Phone calls are a big contributor to
                  that because so many people want to be able to have those
                  meaningful interactions and connect with a real person when
                  they have a query."
                </p>
                <div className="flex flex-row justify-start items-center pt-8.5">
                  <Button
                    variant={"link"}
                    className="text-lg text-[#808080] opacity-80 font-semibold px-4 py-3 min-h-[44px] min-w-[44px]"
                  >
                    Read the full story
                    <span className="pt-1">
                      <ChevronRight />
                    </span>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="relative w-fit">
            <Image
              src={SwoopTeamImg}
              alt="Swoop Team"
              className="rounded-[20px] object-cover md:size-98"
            />
            <Button
              variant={"link"}
              className="text-lg text-white font-semibold px-4 py-3 min-h-[44px] min-w-[44px] absolute bottom-7 md:bottom-9 left-12.5"
            >
              Read the full story
              <span className="pt-1">
                <ChevronRight />
              </span>
            </Button>
          </div>
          <div className="max-h-98 max-w-98">
            <Card className="shadow-none py-9.5 px-12.5 gap-0 rounded-[20px] ">
              <CardHeader className="px-0 gap-0">
                <Image
                  src={PulsTeamImg}
                  alt="Puls Team Member"
                  className="w-18.5 object-cover"
                />
              </CardHeader>
              <CardContent className="px-0 pt-5.5">
                <p className="text-lg font-medium">
                  "We’ve actually been able to set up an IVR that really helps
                  the customer. It drives them to be more self-service on some
                  topics, or reach us faster when they really need to discuss
                  something over the phone."
                </p>
                <div className="flex flex-row justify-start items-center pt-5">
                  <Button
                    variant={"link"}
                    className="text-lg text-[#808080] opacity-80 font-semibold px-4 py-3 min-h-[44px] min-w-[44px]"
                  >
                    Read the full story
                    <span className="pt-1">
                      <ChevronRight />
                    </span>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="max-h-98 max-w-98">
            <Card className="shadow-none py-9.5 px-12.5 gap-0 rounded-[20px] ">
              <CardHeader className="px-0 gap-0">
                <Image
                  src={PulsTeamImg}
                  alt="Puls Team Member"
                  className="w-18.5 object-cover"
                />
              </CardHeader>
              <CardContent className="px-0 pt-5.5">
                <p className="text-lg font-medium">
                  "We’ve actually been able to set up an IVR that really helps
                  the customer. It drives them to be more self-service on some
                  topics, or reach us faster when they really need to discuss
                  something over the phone."
                </p>
                <div className="flex flex-row justify-start items-center pt-5">
                  <Button
                    variant={"link"}
                    className="text-lg text-[#808080] opacity-80 font-semibold px-4 py-3 min-h-[44px] min-w-[44px]"
                  >
                    Read the full story
                    <span className="pt-1">
                      <ChevronRight />
                    </span>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="max-h-98 max-w-98">
            <Card className="shadow-none py-9.5 px-12.5 gap-0 rounded-[20px] ">
              <CardHeader className="px-0 gap-0">
                <Image
                  src={PulsTeamImg}
                  alt="Puls Team Member"
                  className="w-18.5 object-cover"
                />
              </CardHeader>
              <CardContent className="px-0 pt-5.5">
                <p className="text-lg font-medium">
                  "We’ve actually been able to set up an IVR that really helps
                  the customer. It drives them to be more self-service on some
                  topics, or reach us faster when they really need to discuss
                  something over the phone."
                </p>
                <div className="flex flex-row justify-start items-center pt-5">
                  <Button
                    variant={"link"}
                    className="text-lg text-[#808080] opacity-80 font-semibold px-4 py-3 min-h-[44px] min-w-[44px]"
                  >
                    Read the full story
                    <span className="pt-1">
                      <ChevronRight />
                    </span>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div> */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-6 sm:gap-8 lg:gap-12">
          {Testimonial_Company_Team_Review_Card_Stories_Devkrest.map(
            (item, index) => {
              const isDoubleWidth = index === 0;
              const isImageOnly = !!item.team_image && !item.review;

              return (
                <div
                  key={item.id}
                  className={
                    isDoubleWidth ? "sm:col-span-2" : "w-full max-w-[392px]"
                  }
                >
                  {isImageOnly ? (
                    <Link href={item.read_more_url || "#"} className="block">
                      <div className="relative w-full max-w-[392px] mx-auto h-[392px]">
                        {item.team_image && (
                          <Image
                            src={item.team_image}
                            alt={`${item.company} team`}
                            className="rounded-[20px] object-cover w-full h-full"
                          />
                        )}
                        {item.read_more_url && (
                          <Button
                            variant="link"
                            className={`text-lg text-white font-semibold px-4 py-3 absolute min-h-[44px] min-w-[44px] ${item.company === "CaloriePal" || item.company === "Chargeaway" || item.company === "Glowy"
                              ? "bottom-4 md:bottom-6"
                              : "bottom-7 md:bottom-9"
                              }`}
                          >
                            Read the full story
                            <span className="flex items-center">
                              <ChevronRight />
                            </span>
                          </Button>
                        )}
                      </div>
                    </Link>
                  ) : (
                    <Link href={item.read_more_url || "#"} className="block">
                      <Card
                        className={`shadow-none rounded-[20px] w-full gap-4 md:gap-4 h-[392px] flex flex-col ${isDoubleWidth
                          ? "p-6 md:p-10 lg:w-[824px]"
                          : "p-6 md:p-9"
                          }`}
                      >
                        <CardHeader className="px-0 gap-0 flex-shrink-0">
                          {item.logo && (
                            <Image
                              src={item.logo}
                              alt={`${item.company} logo`}
                              className={
                                isDoubleWidth
                                  ? "w-16 h-16"
                                  : "w-18.5 object-cover"
                              }
                            />
                          )}
                        </CardHeader>
                        <CardContent className="px-0 flex flex-col justify-center flex-1">
                          {item.review && (
                            <p className="text-base md:text-lg font-medium">{item.review}</p>
                          )}
                          {item.read_more_url && (
                            <div className="flex flex-row justify-start items-center pt-2 md:pt-5">
                              <Button
                                variant="outline"
                                className="shadow-none rounded-full cursor-pointer px-4 py-2 font-medium text-base"
                              >
                                Read the full story
                              </Button>
                            </div>
                          )}
                        </CardContent>
                      </Card>
                    </Link>
                  )}
                </div>
              );
            }
          )}
        </div>
      </div>
    </ScreenLayout>
  );
};

export default TestimonialReviewSection;
